<script lang="ts">
    import Spinner from '$components/Spinner/Spinner.svelte';
</script>

<div
    class={'shrink-0 group w-32 h-32 border border-gray-300 rounded-lg p-1 shadow-md flex items-center justify-center'}
>
    <Spinner size={'sm'} />
</div>
